var render = function render(){var _vm=this,_c=_vm._self._c;return _c('face-scanner-page-template',{attrs:{"locale":_vm.locale,"language-options":_vm.languageOptions,"user-info":_vm.patientInfo,"doctor-info":_vm.doctorInfo,"photo":_vm.patientPhoto},on:{"change-language":_vm.onChangeLanguage}})
}
var staticRenderFns = []

export { render, staticRenderFns }